import styleResolver from "./styleResolver";
var css = {
  create: function create(rules, group) {
    return styleResolver.createCSS(rules, group);
  }
};
export default css;